import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('arrow-up', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 26 26"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fillOpacity: "0",
    fill: props.colors[1],
    x: "0",
    y: "0",
    width: "26",
    height: "26"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: props.colors[0],
    transform: "translate(13.000000, 13.000000) scale(-1, 1) translate(-13.000000, -13.000000) ",
    points: "13 7 22 19 4 19"
  }))));
});